import React, { useState, useContext } from "react";
import Select from "react-select";
import { Box, Text, Heading, Flex, useToast } from "@chakra-ui/react";
import { OrdersContext } from "../Context/OrdersContext";
import useFetch from "../../hooks/useFetch";
import ConfirmationSwal from "../../Utils/confirmationSwal";
import { currencyFormatter } from "../../Utils/formatUtils";
import { UsersContext } from "../Context/UsersContext";
import { userIsAllowed } from "../../Utils/userIsAllowed";

const SalesBulkAction = () => {
  const [selectedState, setSelectedState] = useState([]);
  const { selectedOrders, getOrders, setSelectedOrders } =
    useContext(OrdersContext);
  const { currentUser } = useContext(UsersContext);
  const toast = useToast();
  const { put } = useFetch();

  const options = [
    { value: "1", label: "Creado" },
    { value: "2", label: "Cargado" },
    { value: "3", label: "Confirmado" },
    { value: "4", label: "Armado" },
    { value: "5", label: "Enviado" },
    { value: "6", label: "Saldo" },
    { value: "7", label: "Finalizado" },
  ];

  const handleSubmit = async (selectedOption) => {
    setSelectedState(selectedOption);

    let text = `¿Desea cambiar el estado de el/los pedidos ${parseOrders(
      selectedOrders
    )} a
          ${selectedOption.label}?`;

    ConfirmationSwal.fire({
      title: "Cambio de estado",
      text: text,
      icon: "question",
      confirmButtonText: "Cambiar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let ordersId = [];

        selectedOrders.forEach((order) => {
          if (
            userIsAllowed(currentUser, [5]) ||
            (userIsAllowed(currentUser, [6]) && order.statusId < 4) ||
            (userIsAllowed(currentUser, [6]) &&
              order.statusId >= 4 &&
              selectedOption.value >= 4) ||
            (userIsAllowed(currentUser, [7]) &&
              selectedOption.value >= order.statusId)
          ) {
            ordersId.push(order.id);
          }
        });

        if (ordersId.length) {
          await put("/orders", {
            ordersId,
            statusId: selectedOption.value,
          })
            .then(() => {
              toast({
                title: "Estados editados con éxito.",
                description: `Se han cambiado los estados de el/los pedidos ${ordersId.join(
                  ", "
                )}`,
                status: "success",
                duration: 4000,
                isClosable: true,
              });
              getOrders();
              setSelectedOrders([]);
            })
            .catch((e) => {
              toast({
                title: "Se ha producido un error.",
                description:
                  e?.message || "Contacte con el administrador del sistema.",
                status: "error",
                duration: 4000,
                isClosable: true,
              });
            });
        }
      }
    });
  };

  const sumTotalselectedOrders = () => {
    let total = 0;
    selectedOrders.map((sale) => {
      total += parseInt(sale.total);
    });
    return currencyFormatter(total);
  };

  const parseOrders = (orderList) => {
    let parsedOrders = "";
    orderList.map((order, key) => {
      parsedOrders += order.id;
      if (orderList.length - 1 == key + 1) parsedOrders += " y ";
      else if (orderList.length > key + 1) parsedOrders += ", ";
    });
    return parsedOrders;
  };

  return (
    <>
      <Heading variant="h2">Acciones en grupo</Heading>
      {userIsAllowed(currentUser, [3]) && (
        <Flex
          spacing="50px"
          align="left"
          color="menu.700"
          justifyContent="space-around"
          flexDirection={["column", "column", "row"]}
        >
          <Box w={["auto", "40%"]} color="black">
            <Text fontSize="md" color="menu.700">
              Cambiar estado a{" "}
            </Text>
            <Select
              options={options}
              value={selectedState}
              onChange={handleSubmit}
              placeholder={"Seleccione un estado"}
            />
          </Box>
        </Flex>
      )}
      <Box
        mt="1.5rem"
        background="menu.200"
        padding="0.4rem"
        fontSize="0.9em"
        textAlign="center"
      >
        Se han seleccionado{" "}
        <Text as="span" fontSize="1.1em" color="text.500">
          {selectedOrders.length}
        </Text>{" "}
        pedidos por un total de
        <Text as="span" fontSize="1.1em" color="text.500">
          {" "}
          {sumTotalselectedOrders()}
        </Text>
        .
      </Box>
    </>
  );
};

export default SalesBulkAction;
